(function(){
    try {
        var zapisany = localStorage.getItem('a11y-motyw');
        var mobile = window.matchMedia && window.matchMedia('(max-width: 639px)').matches;
        var m = zapisany || (mobile ? 'auto' : 'jasny');
        var d = m === 'ciemny' || (m === 'auto' && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches);
        document.documentElement.classList.toggle('a11y-ciemny', d);
        var meta = document.querySelector('meta[name="theme-color"]');
        if (meta) { meta.content = d ? '#121211' : '#ece8e1'; }
    } catch (e) {}
})();
